<template>
  <van-popup
    :value="value"
    @input="$emit('input', $event)"
    position="bottom"
    :style="{ height: '40%' }"
    :round="round"
  >
    <div class="speed-box">
      <div class="header">
        <div class="cancel" @click="onCancel">取消</div>
        <div>{{ title }}</div>
        <div class="confirm" @click="onConfirm">确认</div>
      </div>
      <div class="speed-main">
        <slot />
      </div>
    </div>
  </van-popup>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    round: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closePopper() {
      this.$emit("input", false);
    },
    onCancel() {
      this.closePopper();
      this.$emit("cancel");
    },
    onConfirm() {
      this.closePopper();
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="less" scoped>
.speed-box {
  height: 100%;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100px;
  }

  .header div {
    padding: 0 40px;
    font-size: 32px;
    line-height: 100px;
    height: 100px;
  }

  .speed-main {
    height: calc(100% - 100px);
    overflow-y: auto;
  }

  .cancel,
  .confirm {
    font-size: 26px;
  }

  .confirm {
    font-size: 26px;
    color: #0096dd;
  }
}
</style>
